<template>
  <q-card
    v-touch-repeat.mouse="event => $emit('touch-repeat', event)"
    class="column cursor-pointer"
    :class="(backgroundColor !== 'custom' ? 'bg-' + backgroundColor : '') + ' ' + (textColor !== 'custom' ? 'text-' + textColor : '')"
    :style="{
      'background-color': backgroundColor === 'custom' ? backgroundColorHex : '',
      'color': textColor === 'custom' ? textColorHex : ''
    }"
    flat
    bordered
  >
    <div>
      <transition
        leave-class="hidden"
        enter-active-class="animated bounceIn"
      >
        <q-badge
          v-if="count"
          style="font-size: 18px; z-index: 1"
          class="q-py-sm text-bold"
          color="primary"
          floating
        >
          x {{ count }}
        </q-badge>
      </transition>
    </div>

    <q-img
      :src="giftCardSaleImageUrl(giftCardSale.image, giftCardSale.color) || currentSite.giftCardImageUrl"
    />
    <q-card-section class="column q-pa-xs">
      <div class="text-h6 text-center">
        {{ giftCardSale.name }}
        <i18n-n
          v-if="showPrice"
          :value="giftCardSale.amount"
          format="currency"
          scope="global"
        />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { giftCardSaleImageUrl } from 'src/models/gift-card/GiftCardSale'

export default {
  name: 'GiftCardSaleCard',
  configuration: ['currentSite', 'currentCircuit'],
  props: {
    giftCardSale: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      required: false,
      default: 0
    },
    showPrice: {
      type: Boolean,
      required: false,
      default: true
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'default'
    },
    textColor: {
      type: String,
      required: false,
      default: 'default'
    },
    backgroundColorHex: {
      type: String,
      required: false,
      default: '#FFFFFF'
    },
    textColorHex: {
      type: String,
      required: false,
      default: '#000000'
    }
  },
  emits: ['touch-repeat'],
  created () {
    _.extend(this, { giftCardSaleImageUrl })
  }
}

</script>
